module.exports = __webpack_public_path__ + "static/media/Стрижак Варвара Александровна Вишневый сад. Элегия о времени г. Санкт-Петербург-1.png";